export default __webpack_public_path__ + "media/images/lp/img4-a53610a79fd2e1f69647219edc4d35a0.png";